export interface CorporatePositionSearchDto {
  searchTerm?: string | null;
  pageNumber?: number; // Default: 1
  pageSize?: number; // Default: 10
  corporationId?: string | null; // Guid
  isActive?: boolean | null;
}
